import {changeLanguage} from "../../../config/tolgee";
import Flag from 'react-world-flags'
import KeycloakService from "../../../config/keycloak";
import {Logout} from "@mui/icons-material";
import {T} from "@tolgee/react";

export const languageMenuItems = [
    {
        text: <T keyName="language-name-en"/>,
        icon: <Flag code="GB" style={{width: "28px", height: "28px", marginRight: "0.25em"}} alt="Great Britain" />,
        handleOnClick: () => changeLanguage("en")
    },
    {
        text: <T keyName="language-name-it"/>,
        icon: <Flag code="IT" style={{width: "28px", height: "28px", marginRight: "0.25em"}} alt="Italy" />,
        handleOnClick: () => changeLanguage("it")
    }
]

export const profileMenuItems = [
    {
        text: <T keyName={"text-logout"} defaultValue={"Logout"}/>,
        icon: <Logout sx={{
            marginRight: '0.6em',
            rotate: '180deg',
        }} />,
        handleOnClick: () => KeycloakService.doLogout()
    }
];